<template>
  <div class="bodycontent">
    <div class="page_title">
      {{ $route.query.idE == null ? "新增" : "编辑" }}
    </div>
    <div class="page_form">
      <el-form :model="form" size="small" label-width="120px">
        <el-form-item label="活动名称：">
          <el-input v-model="form.name" style="width:310px"></el-input>
        </el-form-item>
        <el-form-item label="任务数量：">
          <el-input v-model="form.num" style="width:310px"></el-input>
        </el-form-item>
        <el-form-item label="选择会员：">
          {{ selectUserName }}
          <el-button size="small" @click="showSelecterUser = true"
            >选择</el-button
          >
        </el-form-item>
        <el-form-item label="备注">
          <el-col :span="10">
            <el-input
              type="textarea"
              v-model="form.des"
              :rows="12"
              maxlength="150"
              show-word-limit
              placeholder=""
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="save()"
            >确定</el-button
          >
          <el-button size="small" @click="$router.go(-1)">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="save_button">
    </div> -->
    <!-- 會員 -->
    <!-- 选择用户弹窗 -->
    <el-dialog
      :visible.sync="showSelecterUser"
      @close="showSelecterUser = false"
      width="860px"
    >
      <selectCommodity
        @close="showSelecterUser = false"
        @getCommod="getCommodUser"
        :sList="sUserList"
        :jude="4"
        :menuName="'会员'"
      ></selectCommodity>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import { PointsTaskAdd, PointsTaskDetail, PointsTaskEdit } from "@/api/market";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    selectCommodity
  },
  data() {
    return {
      type: [],
      form: {
        name: "", //活动名称
        num: "",
        uid: "",
        des: ""
      },
      options: [], //标签
      level_options: [], //会员等级
      sUserList: [], //已选择用户
      selectUserName: "", //选择的用户名称
      showSelecterUser: false,
      showSelecter: false,
      sList: [],
      point: ""
    };
  },
  mounted() {
    if (this.$route.query.idE != null) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      let data = {
        app_id: this.app_id,
        token: this.token,
        id: 1
      };
      PointsTaskDetail(data).then(res => {
        console.log("res详情", res);
        if (res.code == 200) {
          this.form = res.data;
          this.sUserList = res.data.user;
          this.selectUserName = this.showName(res.data.user);
          delete this.form.create_time;
        }
      });
    },
    getCommodUser(data) {
      console.log("用户id", data);
      this.sUserList = data;
      this.selectUserName = this.showName(data);
      this.showSelecterUser = false;
    },
    showName(data) {
      let selectUserName = "";
      if (data.length > 5) {
        selectUserName =
          data[0].name +
          "," +
          data[1].name +
          "," +
          data[2].name +
          "," +
          data[3].name +
          "," +
          data[4].name +
          "等" +
          data.length +
          "位用户";
      } else {
        selectUserName =
          data.map(n => n.name).join(",") + " 共" + data.length + "位用户";
      }
      return selectUserName;
    },
    save() {
      var data = this.form;
      data.token = this.token;
      data.app_id = this.app_id;

      //参与对象
      if (this.sUserList.length) {
        data.uid = this.sUserList.map(item => item.id).join(",");
      } else {
        this.$message.warning("请选择会员！！");
        return;
      }
      console.log("提交数据", data);
      // return false;
      this.$confirm("确定要添加积分削减任务吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          if (this.$route.query.idE == null) {
            PointsTaskAdd(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.$router.push("integralTask");
              } else {
                this.$message.warning(res.msg);
              }
            });
          } else {
            PointsTaskEdit(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.$router.push("integralTask");
              } else {
                this.$message.warning(res.msg);
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消开启"
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form {
    padding-top: 30px;
    .input_box {
      width: 150px;
      margin-right: 10px;
    }
    .input_box_small {
      width: 50px;
    }
    .form_info_text {
      color: #aaa;
    }
  }
  // 输入框
  .wdth100 {
    width: 100px;
  }
  .save_button {
    margin-top: 25px;
    padding-left: 100px;
    margin-bottom: 50px;
  }
}
</style>
